export default "__VITE_ASSET__BGLMixdm__"